export default (fill) => (
  `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87 94">
  <g fill="${fill? fill : '#882C80'}">
    <path
      d="M86.2 31.3c-.5-4.8-4.1-11.1-7.9-14 0 0-5.8-4.3-13-8.5C58 4.4 51.4 1.5 51.4 1.5 49.2.5 46.3 0 43.5 0c-2.9 0-5.8.5-7.9 1.5 0 0-6.5 2.9-13.8 7.2-7.2 4.3-13 8.5-13 8.5-3.9 2.9-7.4 9.2-7.9 14 0 0-.8 7.2-.8 15.8 0 8.5.8 15.8.8 15.8.5 4.8 4.1 11.1 7.9 14 0 0 5.8 4.3 13 8.6s13.8 7.2 13.8 7.2c2.2 1 5.1 1.5 7.9 1.5 2.9 0 5.8-.5 7.9-1.5 0 0 6.5-2.9 13.8-7.2 7.2-4.3 13-8.6 13-8.6 3.9-2.9 7.4-9.2 7.9-14 0 0 .8-7.2.8-15.8.1-8.5-.7-15.7-.7-15.7zm-4 30.9c-.4 3.8-3.4 9-6.3 11.2-.1 0-5.7 4.2-12.6 8.3-6.9 4.1-13.3 7-13.4 7-1.6.7-3.9 1.1-6.3 1.1s-4.7-.4-6.3-1.1c-.1 0-6.4-2.9-13.4-7-6.9-4.1-12.6-8.3-12.6-8.3-3-2.2-5.9-7.5-6.3-11.2 0-.1-.7-7.1-.7-15.3S5 31.6 5 31.6c.4-3.8 3.4-9 6.3-11.2.1 0 5.7-4.2 12.6-8.3s13.3-7 13.4-7c1.5-.7 3.8-1.1 6.2-1.1 2.4 0 4.7.4 6.3 1.1.1 0 6.4 2.9 13.4 7 6.9 4.1 12.6 8.3 12.6 8.3 3 2.2 5.9 7.5 6.3 11.2 0 .1.7 7.1.7 15.3.2 8.2-.5 15.3-.6 15.3z"/>
    <path
      d="M52.2 24.7c-.7-.7-1.7-1.1-2.8-1.1H29.7c-2.2 0-4 1.8-4 4v37c0 2.2 1.8 4 4 4H58c2.2 0 4-1.8 4-4V35.8c0-1.1-.4-2.1-1.2-2.9l-8.6-8.2zm5.7 11.1h-7.1c-.7 0-1.3-.6-1.3-1.3v-6.7l8.4 8zM29.7 64.5v-37h15.8v6.9c0 2.9 2.4 5.3 5.3 5.3h7.1v24.8H29.7z"/>
    <path
      d="M50.6 43.3c-.8-.8-2-.8-2.8 0L36.3 54.6c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6L50.5 46c.8-.7.8-1.9.1-2.7z"/>
    <ellipse cx="49.3" cy="55.5" rx="2.6" ry="2.6"/>
    <ellipse cx="38.3" cy="44.9" rx="2.6" ry="2.6"/>
  </g>
</svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/uslugas/16.jsx